import { EuiPageTemplate, EuiButton, EuiLink } from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";

export const AlreadyHasPersonalSpace = () => {
  const dashboardRoute = useRouteMapContext((s) => s.routeMap.DASHBOARD);
  return (
    <EuiPageTemplate.EmptyPrompt
      title={<span>You have already created a space</span>}
      footer={
        <EuiButton onClick={() => dashboardRoute.navigateTo()}>
          Go to dashboard
        </EuiButton>
      }
    >
      You can only create one personal space.{" "}
      <EuiLink to={dashboardRoute.path}>Go to your dashboard</EuiLink> to view
      and create projects in your personal space.
    </EuiPageTemplate.EmptyPrompt>
  );
};
